// extracted by mini-css-extract-plugin
module.exports = {"container":"SimpleCarousel_container__3cD9r"};